import React, { useRef, useState, useEffect } from 'react';
import Conditional from '../../../../../components/Conditional/Conditional';
import { truncate } from '../../../../../utils/stringutils';
import { formatUrl } from '../../../../../utils/urlUtil';
import { Description, InfoPopoutContainer, MoreInfoLink, TruncatedLinkText } from './InfoPopout.styles';

const InfoPopout = (props) => {
    const {
        external,

        url,
        index,
        description,
        trackOnClick,
    } = props;
    const ref = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        setHeight(ref.current.scrollHeight);
    }, []);

    const TRUNCATION_LENGTH = 200;

    const shortenedDescription = description ? truncate(description, TRUNCATION_LENGTH) : null;

    return (
        <InfoPopoutContainer ref={ref} height={height}>
            <Conditional condition={shortenedDescription}>
                <Description key={`transition-${index}`}>{shortenedDescription}</Description>
            </Conditional>
            <MoreInfoLink
                isExternal={external}
                to={formatUrl(url, { info: 'visa' })}
                onAfterClick={trackOnClick}
            >
                <TruncatedLinkText>Mer </TruncatedLinkText>om programmet
            </MoreInfoLink>
        </InfoPopoutContainer>
    );
};

export default InfoPopout;
